/**
 * Contexto de la sesión. En su propio módulo por `react-refresh` (§2.3): el
 * provider exporta un componente y nada más.
 */

import { createContext } from 'react';

import type { EstadoModulo, Sesion } from '../api';

export interface ValorSesion {
  /** `null` mientras se consulta el estado del módulo. */
  readonly modulo: EstadoModulo | null;
  readonly sesion: Sesion | null;
  readonly cargando: boolean;
  readonly ingresar: (usuario: string, clave: string) => Promise<void>;
  readonly salir: () => Promise<void>;
  /** Vuelve a leer la sesión del servidor. Lo usa el cambio de clave. */
  readonly recargarSesion: () => Promise<void>;
}

export const ContextoSesion = createContext<ValorSesion | null>(null);
